import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconTrophyGradient = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={34}
    fill="none"
    viewBox="0 0 40 34"
    aria-hidden="true"
    {...props}
  >
    <g filter="url(#icon-trophy-gradient_svg__a)">
      <path
        fill="url(#icon-trophy-gradient_svg__b)"
        d="M31.094 9.742c0 .117.742 3.32-1.407 6.367-1.484 2.188-3.945 3.711-7.343 4.61a1.676 1.676 0 0 0-1.211 1.601c0 .938.742 1.68 1.68 1.68h.195c1.015 0 1.875.86 1.875 1.875 0 .352-.235.625-.586.625h-8.711c-.313 0-.586-.273-.586-.625 0-1.016.82-1.875 1.875-1.875h.156c.938 0 1.719-.742 1.68-1.68 0-.742-.469-1.406-1.211-1.601-3.398-.899-5.86-2.422-7.305-4.61-2.07-3.047-1.328-6.25-1.328-6.367.117-.43.508-.742.938-.742h3.945a7.083 7.083 0 0 1 0-1.29c0-.663.547-1.21 1.25-1.21h9.96c.704 0 1.25.547 1.25 1.21.04.392.04.821 0 1.29h3.946c.43 0 .82.313.938.742Zm-19.336 5.352c.898 1.367 2.344 2.422 4.258 3.203-1.446-2.266-2.032-5.078-2.266-7.422h-3.125c-.04.938.04 2.617 1.133 4.219Zm16.445 0c1.094-1.602 1.172-3.281 1.133-4.219H26.21c-.234 2.344-.82 5.156-2.266 7.422 1.914-.781 3.36-1.836 4.258-3.203Z"
      />
    </g>
    <defs>
      <linearGradient
        id="icon-trophy-gradient_svg__b"
        x1={30}
        x2={11.025}
        y1={7}
        y2={26.974}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={0.18} stopColor="#EEE" />
        <stop offset={0.73} stopColor="#A0A0A0" />
        <stop offset={1} stopColor="#979797" />
      </linearGradient>
      <filter
        id="icon-trophy-gradient_svg__a"
        width={39.711}
        height={36}
        x={0.125}
        y={0.5}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_6025_5409"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_6025_5409"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_6025_5409"
          result="effect2_dropShadow_6025_5409"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_6025_5409"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
));
export default SvgIconTrophyGradient;
